module.exports = __webpack_public_path__ + "img/831.ffe441f3.png";